import type { ListBuilderList } from '../../../types';
import { createClientColumnsNoLifecycle } from '../columns';
import {
	ACTIVITY_LIST_ACTIVE_FILTERS,
	CLIENT_MOBILE_CARD_CONFIG,
	SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
	createClientKanbanConfig,
} from '../shared';

/**
 * Suggested Sales (Reorder) list configuration
 * Customers due for reorder based on historical ordering patterns
 */
export const suggestedSalesList: ListBuilderList = {
	id: 'suggested-sales-list',
	cacheTTL: 600000,
	name: 'Reorder',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	columns: createClientColumnsNoLifecycle(),
	mobileCardConfig: CLIENT_MOBILE_CARD_CONFIG,
	description:
		'Customers due for reorder based on historical ordering patterns',
	defaultSortId: 'forecast',
	requiredFields: [
		'client._id',
		'client.address1',
		'client.averageInvoiceRevenue',
		'client.businessType',
		'client.city',
		'client.companyNames',
		'client.email',
		'client.externalId',
		'client.externalId2',
		'client.fax',
		'client.forecast',
		'client.forecastedReorderDate',
		'client.googlePlaceId',
		'client.latitude',
		'client.leadOrCustomer',
		'client.longitude',
		'client.monthlyData',
		'client.name',
		'client.nextActivityDate',
		'client.phone',
		'client.salesStatus',
		'client.state',
		'client.trend',
		'client.zip',
	],
	// PD-16724: the Reorder Due chip is shown so a rep can widen or narrow the
	// tab's reorder window; the other activity lists do not carry it.
	activeFilters: [...ACTIVITY_LIST_ACTIVE_FILTERS, 'reorderDue'],
	sortOrder: 4,
	filterRules: {
		...SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
		callStatus: {
			defaultValue: [
				{
					id: 'Callable',
					label: 'Callable',
				},
			],
		},
		leadOrCustomer: {
			defaultValue: [
				{
					id: 'Customer',
					label: 'Customer',
				},
			],
		},
		// PD-16724: the tab used to default Special Filters to `reorder_due`, an
		// id that filter never offered and the server never handled, so nothing
		// was filtered and every callable customer was listed. The Reorder Due
		// filter is the one that actually narrows on forecastedReorderDate;
		// "Due This Week" is overdue plus the next 7 days.
		reorderDue: {
			defaultValue: [
				{
					id: 'thisWeek',
					label: 'Due This Week',
				},
			],
		},
	},
	kanbanConfig: createClientKanbanConfig(),
};
